/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

export const UPDATE_COLUMN_ORDER = 'UPDATE_COLUMN_ORDER';
export const RESET_COLUMN_ORDER = 'RESET_COLUMN_ORDER';

export interface ColumnOrderItem {
  slice_id: number;
  columns: string[];
}

export interface ColumnOrderState {
  [slice_id: number]: string[];
}

export interface UpdateColumnOrderAction {
  type: typeof UPDATE_COLUMN_ORDER;
  slice_id: number;
  columns: string[];
}

export interface ResetColumnOrderAction {
  type: typeof RESET_COLUMN_ORDER;
  slice_id: number;
}

export type ColumnOrderAction =
  | UpdateColumnOrderAction
  | ResetColumnOrderAction;

const initialState: ColumnOrderState = {};

export default function columnOrderReducer(
  state: ColumnOrderState = initialState,
  action: ColumnOrderAction,
): ColumnOrderState {
  switch (action.type) {
    case UPDATE_COLUMN_ORDER:
      return {
        ...state,
        [action.slice_id]: action.columns,
      };
    case RESET_COLUMN_ORDER:
      const newState = { ...state };
      delete newState[action.slice_id];
      return newState;
    default:
      return state;
  }
}
